module.exports = __webpack_public_path__ + "img/security-1.2fa6d0f2.png";